
/**
 * Check if a file is an animated GIF
 */
export const isAnimatedGif = async (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    // If it's not a gif, it's not animated
    if (!file.type.includes('image/gif')) {
      resolve(false);
      return;
    }
    
    // For GIFs, we need to check if it has multiple frames
    const reader = new FileReader();
    reader.onload = (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      
      // Simple check for animated GIF - look for multiple image descriptors
      // This is a simplified check and might not be 100% accurate
      const bytes = new Uint8Array(buffer);
      let frames = 0;
      
      // Look for image descriptors (0x2C)
      for (let i = 0; i < bytes.length - 1; i++) {
        if (bytes[i] === 0x2C) {
          frames++;
          if (frames > 1) {
            // More than one frame means it's animated
            resolve(true);
            return;
          }
        }
      }
      
      resolve(false);
    };
    
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Convert a PSD file to an image format
 * Note: This is a placeholder. In a real app, this would use a service
 * to convert PSD to other formats
 */
export const convertPsdToImage = async (file: File): Promise<string> => {
  // In a real implementation, this would send the PSD to a service
  // that can render it as an image
  return new Promise((resolve) => {
    // For demo purposes, we'll just return a placeholder image
    resolve(`https://picsum.photos/800/600?random=${Date.now()}`);
  });
};

/**
 * Check if a URL points to an animated GIF
 * Note: This is a basic check based on file extension
 */
export const isAnimatedGifUrl = (url: string): boolean => {
  return url.toLowerCase().endsWith('.gif');
};
